module.exports = __webpack_public_path__ + "img/04.fe73c6f6.jpg";